var React = require('react');

function IconQuotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 11.25H4.58a6.75 6.75 0 012.92-4.6l1.34-.9-.82-1.25-1.34.9A8.25 8.25 0 003 12.26v4.99a1.5 1.5 0 001.5 1.5H9a1.5 1.5 0 001.5-1.5v-4.5a1.5 1.5 0 00-1.5-1.5zM19.5 11.25h-4.42A6.75 6.75 0 0118 6.65l1.34-.9-.82-1.25-1.34.9a8.25 8.25 0 00-3.68 6.86v4.99a1.5 1.5 0 001.5 1.5h4.5a1.5 1.5 0 001.5-1.5v-4.5a1.5 1.5 0 00-1.5-1.5z"}));
}

IconQuotes.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconQuotes;

IconQuotes.default = IconQuotes;
